import { render, staticRenderFns } from "./GiveFeedback.vue?vue&type=template&id=27963eb4&scoped=true&lang=pug&"
import script from "./GiveFeedback.vue?vue&type=script&lang=js&"
export * from "./GiveFeedback.vue?vue&type=script&lang=js&"
import style0 from "./GiveFeedback.vue?vue&type=style&index=0&id=27963eb4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27963eb4",
  null
  
)

export default component.exports